PJS = window.PJS || {};

(function ($) {
  var $window = $(window);

  // TypeCheck class (used by PJS.helpers.checkIf)
  var TypeCheck = function (entity) {
    this.entity = entity;
  };
  TypeCheck.prototype = $.extend({}, TypeCheck.prototype, {
    is: function (type) {
      switch (type) {
        case 'function': case Function:
          return typeof this.entity === 'function';
        case 'array': case Array:
          return Array.isArray(this.entity);
        case 'string': case String:
          return typeof this.entity === 'string';
        case 'number': case Number:
          return typeof this.entity === 'number';
        case undefined:
          return this.entity === undefined;
        case null:
          return this.entity === null;
        default:
          return this.entity instanceof type;
      }
    },
    isNot: function (type) {
      return !this.is(type);
    }
  });

  PJS.helpers = {
    utmParam: null,
    updateHistoryState: null,
    desktopSize: 1024,
    window: $window,
    scrollingDown: false,
    lastScrollTop: 0,
    env: "unknown",

    init: function () {
      var _this = this;
      _this.utmParam = window.location.href.split('/').pop().split('#')[0].split(".php").pop();
      _this.eventHandlers();
      _this.setenv();
    },
    setenv: function () {
      var _this = this;
      switch (window.location.host) {
        case "unitedforimpact.org":
        case "www.unitedforimpact.org":
          _this.env = "live";
          break;
        case "unitedforimpactstage.wpengine.com":
        case "stage.unitedforimpact.org":
        case "unitedimpact.wpengine.com":
          _this.env = "stage";
          break;
        case "dev.unitedforimpact.org":
        case "new.unitedforimpact.org":
        case "localhost:8848":
          _this.env = "dev";
          break;
      }
    },
    isLive: function () {
      return this.env == "live";
    },
    isStage: function () {
      return this.env == "stage";
    },
    isDev: function () {
      return this.env == "dev";
    },
    eventHandlers: function () {
      var _this = this;
      PJS.documentEvents.onScroll(_this.updateScrollDirection.bind(_this), true);
    },
    isMobileSize: function () {
      return (PJS.helpers.window.width() < PJS.helpers.desktopSize);
    },
    isDesktopSize: function () {
      return (PJS.helpers.window.width() >= PJS.helpers.desktopSize);
    },
    firecustomGTMEvent: function (eventName, eventLabel, eventAction, customVars) {
      console.log("firing GTM event: " + eventName + " : " + eventAction + " : " + eventLabel);
      window.dataLayer = window.dataLayer || [];

      dataPush = {
        'event': eventName
      };

      if (eventAction) {
        dataPush['eventAction'] = $.trim(eventAction);
      }

      if (eventLabel) {
        dataPush['eventLabel'] = $.trim(eventLabel);
      }

      if (customVars) {
        $.each(customVars, function (a, b) {
          dataPush[a] = b;
        });
      }
      console.log(dataPush);

      ///window.dataLayer.push(dataPush);  // ONLY FOR TAG MANAGER


      if (typeof (ga) == "function") {
        ga('send', {
          hitType: 'event',
          eventCategory: dataPush['event'],
          eventAction: dataPush['eventAction'],
          eventLabel: dataPush['eventLabel']
        });
      }

    },
    updateScrollDirection: function () {
      var _this = this;
      var st = _this.window.scrollTop();
      if (st > _this.lastScrollTop) {
        _this.scrollingDown = true;
        $("body").addClass("scrollingdown");
      } else {
        $("body").removeClass("scrollingdown");
        _this.scrollingDown = false;
      }
      _this.lastScrollTop = st;
    },
    updateState: function (url) {
      var _this = this;
      window.clearTimeout(_this.updateHistoryState);
      // Set a timeout to run after scrolling ends
      _this.updateHistoryState = setTimeout(function () {
        // Run the callback
        if (url == "") {
          _this.removeHash();
        }
        else {
          history.replaceState(null, document.title, url);
        }

      }, 40);
    },
    removeHash: function () {
      history.pushState("", document.title, window.location.pathname + window.location.search);
    },
    getQParams: function (qp) {
      try {
        r = unescape(location.search.match(new RegExp(qp + "=+([^&]*)"))[1]);
      }
      catch (e) {
        r = '';
      }
      return r;
    },
    //setQParams("param1","foo"); //pushes a new history state of ?param1=foo
    //setQParams({param1:"foo",param2:"bar"}); //pushes multiple changes
    //setQParams({param3:"another foo"},{type:"replace"}); //replace history instead of push
    setQParams: function (key, value, options) {
      var baseUrl = [location.protocol, '//', location.host, location.pathname].join(''),
        q = document.location.search,
        changes = {},
        aType = typeof (key),
        clear = false;

      if (aType == "string") {
        changes[key] = value;
      } else if (aType == "object") {
        changes = key;
        options = value;
      } else if (key === false) {
        clear = true;
      }
      //Options
      if (!options) options = {};
      var historyType = options.type ? options.type : "push",
        state = options.state ? options.state : {},
        title = options.title ? options.title : "";

      if (clear) {
        q = "";
      } else {
        var escapeRegExp = function (string) { return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') };
        for (var key in changes) {
          var value = changes[key];
          var newParam = key + '=' + encodeURIComponent(value);
          var updateRegex = new RegExp('([\?&])' + escapeRegExp(key) + '[^&]*');
          var removeRegex = new RegExp('([\?&])' + escapeRegExp(key) + '=[^&;]+[&;]?');

          if (typeof value == 'undefined' || value == null || value == '') { // Remove param if value is empty
            q = q.replace(removeRegex, "$1");
            q = q.replace(/[&;]$/, "");
          } else if (q.match(updateRegex) !== null) { // If param exists already, update it
            q = q.replace(updateRegex, "$1" + newParam);
          } else { // Otherwise, add it to end of query string
            var join = q ? "&" : "?";
            q = q + join + newParam;
          }
        }
      }

      if (q == "?") q = "";
      window.history[historyType + "State"](state, title, baseUrl + q);

      return !!q; //Return true if there's a query string, false otherwise
    },
    debounce: function (func, wait, immediate) {
      var timeout;
      wait = wait || 100;
      return function () {
        var context = this, args = arguments;
        var later = function () {
          timeout = null;
          if (!immediate) { func.apply(context, args); }
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) { func.apply(context, args); }
      };
    },

    // Type checker
    //
    // @param {Mixed} something - The entity to check
    // @return  {}    -
    //
    // USAGE:
    // PJS.helpers.checkIf( someObject ).is( typetoCheck );
    // PJS.helpers.checkIf( [] ).is( Array ) // -> true
    // PJS.helpers.checkIf( [] ).is( 'array' ) // -> true
    checkIf: function (something) {
      return new TypeCheck(something);
    },

    /*
     * Dynamically load a javascript from url
     */
    loadScript: function (url, callback) {
      jQuery.ajax({
        url: url,
        dataType: 'script',
        success: callback,
        async: true
      });
    },
    formatnum: function (val) {
      var _this = this;
      if (val == "") {
        return "0";
      }
      //val = val.toString().replace(/\D/g,''); // string all special chars
      val = val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return val;
    },
    // returns the multiplier for decimal to convert to integer
    getMult: function (_num) {
      var _mult = 1;
      var _check = _num * _mult;
      _num = _num.replace(/,/g, ''); // remove all commas  
      if (isNaN(_num)) {
        console.log("[getMult] NaN error: " + _num);
        return 1;
      }
      var _counter = 0;
      while (_check % 1 != 0) {
        _mult = _mult * 10;
        _check = _num * _mult;
        _counter++;
        if (_counter > 100) {
          console.log("[getMult] loop error: " + _num);
          return 1;
          break;
        }
      }
      return _mult;
    },
    isMobile: function () {
      var check = false;
      (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) { check = true; } })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    },

    detectMobile: function () {
      var _iOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
      var _supportsTouch = 'ontouchstart' in window || navigator.msMaxTouchPoints;

      var ua = navigator.userAgent.toLowerCase();
      var _Android = ua.indexOf("android") > -1;

      var _isMobile = this.isMobile();

      if (true === _isMobile) {
        $('body').addClass('is-mobile');
      }

      if (true === _Android) {
        $('body').addClass('is-android');
      }

      if (true === _iOS) {
        $('body').addClass('is-iOS');
      }

      if (true === _supportsTouch) {
        $('body').addClass('has-touch');
      }

    },

    /*
     * Create a slug from a string
     */
    slugify: function (text) {
      return text.toString().toLowerCase()
        .replace(/\s+/g, '-')     // Replace spaces with -
        .replace(/[^\w\-]+/g, '')   // Remove all non-word chars
        .replace(/\-\-+/g, '-')     // Replace multiple - with single -
        .replace(/^-+/, '')       // Trim - from start of text
        .replace(/-+$/, '');      // Trim - from end of text
    }
  };
})(jQuery);
